export const formatDateRms = 'YYYY-MM-DD';
